import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"CampaignOperatorGameConfig Details"}
                            endpoint={"freespin-offer/read"}
                            relations={["operator_game_config", "transaction_freespin_offer", "transaction_freespin_offer.transaction", "player_currency.player", "player_currency.currency"]} 
/>
}

export default GameSessionDetailsPage;